import * as React from "react";
const SvgFiRrFloor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-floor_svg__a)">
      <path
        fill="#062147"
        d="m1.239 9.575 8.551 4.847c.682.387 1.446.58 2.21.58s1.529-.193 2.211-.58l8.55-4.848C23.537 9.134 24 8.359 24 7.499s-.463-1.635-1.239-2.075L14.211.578a4.51 4.51 0 0 0-4.421 0L1.239 5.425C.463 5.865 0 6.64 0 7.5s.463 1.635 1.239 2.075m11.986 3.107a2.53 2.53 0 0 1-2.449 0l-3.011-1.707 5.493-3.095 4.231 2.384zM22 7.5c0 .077-.029.224-.226.334L19.52 9.112l-4.225-2.38 2.867-1.615 3.613 2.049c.196.111.225.257.225.334M10.776 2.318A2.5 2.5 0 0 1 12 2.002c.426 0 .853.105 1.225.316l2.906 1.648-5.553 3.129L6.452 4.77zM2.225 7.166l2.196-1.245 4.12 2.322-2.806 1.581-3.509-1.99c-.196-.111-.225-.257-.225-.334s.029-.224.225-.334zm21.638 4.996a1 1 0 0 1-.358 1.368l-9.282 5.433a4.51 4.51 0 0 1-4.433.007L.51 13.752a1 1 0 0 1 .981-1.743l9.283 5.219a2.53 2.53 0 0 0 2.452.001l9.271-5.426a1 1 0 0 1 1.368.357zm0 4.454a1 1 0 0 1-.358 1.368l-9.282 5.433a4.51 4.51 0 0 1-4.433.006L.51 18.205a1 1 0 0 1 .981-1.743l9.283 5.219a2.53 2.53 0 0 0 2.452.001l9.271-5.426a1 1 0 0 1 1.368.358z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-floor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFloor;
